import React, { useEffect,  useState } from 'react'

import { InputText } from 'primereact/inputtext';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers/rootReducer';
import { validatePostalAndGetAvailableDays } from '../../actions/calendar';
import * as Yup from "yup";
import { getWashingTime } from '../../utils/customSelectors';
import { useHistory } from 'react-router-dom';
import { setPostalCode } from '../../actions/order';
import { useTranslation } from 'react-i18next';

const schema = Yup.string()
.required('Syötä postinumero')
.matches(/^[0-9]+$/, "Syötä ainoastaan numeroita")
.max(5, "");


interface CalendarPostalcodeProps {
    minWashingTime?: number;
}

const CalendarPostalcode = ({ minWashingTime = 0 }: CalendarPostalcodeProps) => {

    const history = useHistory();
    const prevPage = () => history.push('/')
    const {postalCode} = useSelector((state:RootState) => state.order.order.address)
    const [currentPostalCode, setCurrentPostalCode] = useState<string|any>('')
    const [lastValidatedPostalCode, setlastValidatedPostalCode] = useState<string|any>('')
    const { available_dates } = useSelector((state:RootState) => state.calendar)

    const [errorMessage, setErrorMessage ] = useState<string>()
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const washing_time = useSelector((state:RootState) => getWashingTime(state))
    const requestedWashingTime = Math.max(washing_time, minWashingTime);
    
    // if postalCode gived in counter page get available dates based on that code

    
    useEffect(() => {
        if(postalCode && postalCode.length === 5){
            setCurrentPostalCode(postalCode)
            setlastValidatedPostalCode(postalCode)
            dispatch(validatePostalAndGetAvailableDays(postalCode, requestedWashingTime))
        }
    },[postalCode, dispatch, requestedWashingTime])

    useEffect(()=> {
        if(!isNaN(requestedWashingTime) && currentPostalCode.length === 5 && lastValidatedPostalCode !== currentPostalCode){
            setErrorMessage('');
            setlastValidatedPostalCode(currentPostalCode)
            dispatch(setPostalCode(currentPostalCode))
            dispatch(validatePostalAndGetAvailableDays(currentPostalCode, requestedWashingTime))
        }
    },[lastValidatedPostalCode, currentPostalCode, requestedWashingTime, dispatch])

    useEffect(() => {
        if (!available_dates && currentPostalCode.length === 5) {
            setErrorMessage('Antamallesi postinumeroalueelle ei löydy vapaita aikoja')
        } else {
            setErrorMessage('')
        }
    }, [available_dates, currentPostalCode])

    const validateInput = (value:any) => {
        if(value.length > 0 ) {
            schema.validate(value)
            .then(function (valid) {
                setCurrentPostalCode(value)
                setErrorMessage('')
            })
            .catch(function (err:any) {
                setErrorMessage(err.errors[0])
            });
        }else{
            setCurrentPostalCode(value)
        }
    }

    return <div className="box postal-wrapper-box">

        <button className="cal-prev-btn" onClick={() => prevPage()}>
            <span className="prev-page-icon pi pi-chevron-left"></span>
        </button>
        <span className="p-float-label">
            <div className="postal-code-box">
                <InputText 
                    value={currentPostalCode}
                    onChange={(e:any) => validateInput(e.target.value)}
                    maxLength={5}
                    autoFocus={true}
                    id="postal" 
                    name="postal-code" />
                <label htmlFor="postal">{t('postal_code')}</label>
            </div>
                {errorMessage && <p className="error-messagee">{errorMessage}</p> }
        </span>
        </div>
}

export default CalendarPostalcode;